import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Route, Switch, useHistory, useLocation } from "react-router-dom";
import styled from "styled-components";

import { isPrintMode, getQueryParameter } from "commons/src/QueryParameter";

import { AdviserViewContainer } from "../routes/AdviserView/AdviserViewContainer";
import { LoginContainer } from "../routes/Login/LoginContainer";
import { ForgottenPasswordContainer } from "../routes/Login/ForgottenPasswordContainer";
import { RegisterContainer } from "../routes/Login/RegisterContainer";
import { ResetPasswordContainer } from "../routes/Login/ResetPasswordContainer";
import { Terms } from "../routes/Legal/Terms";
import { clearRedirect } from "./DataOperations";
import { ClientRoutesContainer } from "./ClientRoutes";
import { Error } from "./Error";
import { FourOhFour } from "./FourOhFour";
import { routes } from "../helpers/RouteHelpers";

export function NuRouter({
    redirect,
    children,
    defaultPrintRoute = routes.client.folioDetails({ accountNum: "Combined" })
}) {
    const [printRoute, setPrintRoute] = useState("");
    const history = useHistory();
    const { search } = useLocation();

    useEffect(() => {
        if (isPrintMode(search)) {
            const newPrintRoute = getQueryParameter(search, "printRoute")?.[1] || defaultPrintRoute;
            setPrintRoute(newPrintRoute);
        }

        if (redirect || printRoute) {
            history.push(redirect || printRoute);
        }

        return () => {
            clearRedirect();
            setPrintRoute("");
        };
    }, [redirect, printRoute, defaultPrintRoute, history, search]);

    return (
        <Main>
            <Switch>
                {children}
                <Route
                    exact
                    path={[routes.public.root(), routes.public.login()]}
                    component={LoginContainer}
                />
                <Route path={routes.public.error()} component={Error} />
                <Route path={routes.public.forgotten()} component={ForgottenPasswordContainer} />
                <Route path={routes.public.register()} component={RegisterContainer} />
                <Route path={routes.public.reset()} component={ResetPasswordContainer} />
                <Route path={routes.public.terms()} component={Terms} />
                <Route path={routes.client.root()} component={ClientRoutesContainer} />
                <Route path={routes.adviser.root()} component={AdviserViewContainer} />
                <Route component={FourOhFour} />
            </Switch>
        </Main>
    );
}

const Main = styled.main`
    display: flex;
    justify-content: center;
    min-height: calc(100vh - ${props => props.theme.topBarHeightMobile});
    @media (min-width: ${props => props.theme.minWidth}) {
        min-height: calc(100vh - ${props => props.theme.topBarHeightDesktop});
    }
`;

NuRouter.propTypes = {
    redirect: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.array, PropTypes.object]),
    defaultPrintRoute: PropTypes.string
};
